import request from '../utils/request';

export const fetchRefundSummary = () => request.get('/admin/analytics/refunds/summary');
export const fetchRefundTrend = (params) => request.get('/admin/analytics/refunds/trend', { params });
export const fetchRefundReasons = (params) => request.get('/admin/analytics/refunds/reasons', { params });
export const fetchTopRefundProducts = (params) => request.get('/admin/analytics/refunds/top-products', { params });
